import { useEffect } from "react";

export default function useMetadata(title, description) {
  useEffect(() => {
    if (title) {
      document.title = `${title} | Godske Byg & Anlæg`;
    } else {
      document.title = "Godske Byg & Anlæg | Jord-, grave- og anlægsarbejde";
    }

    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement("meta");
        metaDesc.setAttribute("name", "description");
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute("content", description);
    }
  }, [title, description]);
}
